import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const TextFieldStyled = styled(TextField)`
  input {
    text-align: center;
    border-radius: 8px;
    padding: 0px;
    height: 56px;
  }
`;

export default {
  TextFieldStyled,
};
